import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SwiperModule } from 'swiper/angular';

import { ProductContextDirective } from 'ish-core/directives/product-context.directive';

import { DotCmsDynamicProducts } from '../dot-cms-uve-product-carousel-list.component';
import { DotCmsUveProductItemComponent } from '../dot-cms-uve-product-item/dot-cms-uve-product-item.component';

@Component({
  selector: 'custom-dot-uve-cms-product-swiper',
  templateUrl: './dot-cms-uve-product-swiper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, SwiperModule, DotCmsUveProductItemComponent, ProductContextDirective],
})
export class DotCmsUveProductSwiperComponent {
  readonly swiperProducts = input<DotCmsDynamicProducts>(undefined);
  productCarouselCss(): string {
    const configureSlides =
      this.swiperProducts().contentlet.slideItems < this.swiperProducts().products.length
        ? this.swiperProducts().contentlet.slideItems
        : this.swiperProducts().products.length;

    switch (configureSlides) {
      case 1: {
        return 'full-container';
      }
      case 2: {
        return 'half-container';
      }
      case 3: {
        return 'three-container';
      }
      default: {
        return 'four-container';
      }
    }
  }
  getProductCarouselTitle() {
    return this.swiperProducts().contentlet.productCarouselTitle;
  }
}
